import React, { useEffect } from "react";
import "../../../../stylesheets/components/Reports/HoldingReports/MobDownloadDrop.scss";
import { Link } from "react-router-dom";
const MobDownloadDrop = (props) => {
    const downloadBaseURLHolding = `/showholdingReportFormMob`;
    const downloadURLHolding = (props === null || props === void 0 ? void 0 : props.accCodes)
        ? `${downloadBaseURLHolding}?&family=${window.btoa(props.accCodes)}`
        : downloadBaseURLHolding;
    useEffect(() => {
        props.setDownloadSmallcase(false);
    }, []);
    return (React.createElement("div", { className: "mob-download-drop" },
        React.createElement("div", { className: "mob-download-drop-body" },
            React.createElement("ul", null,
                React.createElement("li", null,
                    React.createElement(Link, { to: downloadURLHolding },
                        React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                            React.createElement("div", { className: "menu d-flex align-items-center" },
                                React.createElement("i", { className: "edel-icon-download1" }),
                                React.createElement("p", null, "Download Holdings Report")),
                            React.createElement("div", { className: "openLink" },
                                React.createElement("i", { className: "edel-icon-arrow-right1" }))))),
                React.createElement("li", null,
                    React.createElement(Link, { to: "/showDPTransactionFormMob" },
                        React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                            React.createElement("div", { className: "menu d-flex align-items-center" },
                                React.createElement("p", null, "Pull DP transactions for older date ")),
                            React.createElement("div", { className: "openLink" },
                                React.createElement("i", { className: "edel-icon-arrow-right1" })))))))));
};
export default MobDownloadDrop;
